const errors = {
  OLD_BROWSER_LOGIN_ERROR: [
    {
      description: "LOGIN_ERROR_OLD_SAFARI_FIREFOX",
      rawErrors: [
        "Attempting to change access mechanism for an unconfigurable property.",
        "can't redefine non-configurable property 'length'",
      ],
      userMsg:
        "Unsupported browser detected. Please update your browser or switch to a supported browser (e.g. Chrome).",
    },
    {
      description: "LOGIN_ERROR_OLD_CHROME",
      rawErrors: [
        "Cannot redefine property: arguments",
        "Cannot redefine property: length",
      ],
      userMsg:
        "Unsupported browser detected. Please update your browser or switch to a supported browser (e.g. Firefox, Safari)",
    },
    {
      description: "LOGIN_ERROR_IE",
      rawErrors: ["Cannot redefine non-configurable property 'caller'"],
      userMsg:
        "Unsupported browser detected. Please switch to a supported browser (e.g. Chrome, Firefox, Safari).",
    },
  ],
  USER_NOT_VERIFIED: "UserNotConfirmedException",
  // a toast message shown to the user when we had to reset their renderConfig
  // because it was corrupted
  RENDER_CONFIG_RESET_TOAST:
    "Uh oh! Part of this Group Video's settings were out of date. We've attempted to preserve your choices, but double-check them before creating the Group Video. If this happens again, please contact us.",
  RENDER_V3_DISABLED:
    "The new Group Video creator is temporarily disabled. You may still use the original creator.",
  COMPILATION_USER_INPUT_INCOMPLETE:
    "Please complete the theme settings before creating a Group Video.",
};

export default errors;
